import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiEye, FiSend, FiTarget } = FiIcons;

const EmailMarketing = () => {
  const emailStats = [
    { icon: FiSend, label: 'Total sponsor branded email sends', value: '53,528' },
    { icon: FiEye, label: 'Average open rate', value: '>60%' },
    { icon: FiMail, label: 'Email types', value: 'Welcome, Reminders, Daily Replays, Wrap-up' },
    { icon: FiTarget, label: 'Sponsor visibility', value: 'Every single email with sponsor branding' }
  ];

  return (
    <motion.div
      className="glass-effect rounded-2xl p-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="text-center mb-8">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <SafeIcon icon={FiMail} className="text-proactuary-blue-400 mr-3" />
          Branded Email Marketing Impact
        </motion.h2>
        <div className="w-24 h-1 bg-gradient-to-r from-proactuary-blue-500 to-proactuary-green-500 mx-auto rounded-full" />
      </div>

      <div className="glass-effect rounded-xl p-6 mb-6 border border-proactuary-blue-500/30">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {emailStats.map((stat, index) => (
            <motion.div
              key={index}
              className="flex items-center justify-between p-4 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="flex items-center space-x-3">
                <SafeIcon icon={stat.icon} className="text-proactuary-blue-400 text-xl" />
                <span className="text-white/90">{stat.label}:</span>
              </div>
              <span className="font-bold text-white">{stat.value}</span>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        className="bg-gradient-to-r from-proactuary-green-500/20 to-proactuary-blue-500/20 rounded-xl p-6 border border-proactuary-green-500/30"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4 }}
      >
        <h3 className="text-xl font-bold text-white flex items-center mb-4">
          <SafeIcon icon={FiTarget} className="text-proactuary-green-400 mr-2" />
          Marketing Intelligence
        </h3>
        <p className="text-white/90 leading-relaxed">
          Each email reached actuaries with your branding prominently displayed through ProActuary's trusted communication channels. With a 60%+ open rate, your brand achieved over <span className="font-bold text-proactuary-green-300">32,000 active impressions</span> through email marketing alone.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default EmailMarketing;